import { type NodeProps, Position } from '@xyflow/react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import { Connector } from '@utils/flows';

import { ConnectionPoint, DeleteButton } from '@components/Flows/components/partials/index';

import s from './DebtCollectionNode.module.css';

type DebtCollectionNodeProps = NodeProps & {
  onDelete: (nodeId: string) => void;
};
function DebtCollectionNode({ id, onDelete }: DebtCollectionNodeProps) {
  return (
    <div className={s.container}>
      <ConnectionPoint type={Connector.Target} position={Position.Top} id="incoming" />
      <h1 className={s.title}>Debt Collection Node</h1>
      <DeleteButton onDelete={() => onDelete(id)} />
      <div className={s.body}>
        <div className={s.iconWrap} aria-hidden>
          <AccountBalanceIcon className={s.icon} />
        </div>
        <div className={s.textCol}>
          <p className={s.eyebrow}>Debt collection flow</p>

          <p className={s.hint}>Not Editable</p>
        </div>
      </div>
      <ConnectionPoint type={Connector.Source} position={Position.Right} id="outgoing" />
    </div>
  );
}

export default DebtCollectionNode;
